import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-input-link',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './link.input.design.html',
    styleUrls: ['./link.input.design.scss'],
    standalone: false
})
export class LinkInputDesign {
  @Input() formField = true;
  @Input({ required: true }) name!: string;
  @Input() inputClass: FlatModels.ButtonDesignModels.ButtonDesignClass = FlatModels.ButtonDesignModels.ButtonDesignClass.LINK;
  @Input() iconClass?: FlatModels.ButtonDesignModels.ButtonDefaultIcons;
  @Input({ required: true }) label!: string;
  @Input() routerLink?: string;
  @Input() href?: string;
  @Input() target = '_blank';
}
